import styles from './Search.module.css';
import { useRef, useState } from 'react';
import TextField from '../Base/TextField/TextField';
import * as React from 'react';

export default function Search({
	resultContent,
	handleSearch,
	placeholder,
	marginTop = null,
	label = null,
}) {
	const inputRef = useRef(null);

	return (
		<div
			className='search-user search-user-toggleable'
			style={{ marginTop: marginTop }}
		>
			<div className='search-user-wrapper'>
				<div className='search-user-wrapper__input-wrapper'>
					<div className='form-group mb-2'>
						{label && (
							<div className={'col-form-label'}>
								<label>{label}</label>
							</div>
						)}
						<TextField
							ref={inputRef}
							onChange={handleSearch}
							placeholder={placeholder}
							className={styles.searchInput}
							wrapperClassName={styles.wrapper}
							bounce={350}
							selfValue
						/>
					</div>
				</div>
				{resultContent}
			</div>
		</div>
	);
}
